// The group search endpoint hides empty non-parent groups server-side, but
// empty parent accounts always come back (and users with the view_empty_group
// permission receive every empty group). site_count and group_count are
// direct-child counts annotated on every result, so a group with zero of both
// has nothing to show when clicked.
export const filterEmptySearchResultGroups = (results: any) => {
  if (!Array.isArray(results)) {
    return [];
  }
  return results.filter(
    (group: any) => group?.site_count !== 0 || group?.group_count !== 0
  );
};
